<template>
  <div id="iOSLanding">
      <div class="splashLogoContainer">
        <img class="splashLogoTop" src="../assets/images/SplashLogoTop.png">
        <img class="splashLogoBottom" src="../assets/images/SplashLogoBottom.png">
      </div>
      <div class="intro">
        <p>Welcome to <a href="https://muster.io/" target="_blank">Muster</a>, the most efficient way to get together.</p>
        <p>Let's get the Muster app installed on your iOS device from the Apple App Store.</p>
        <br/>
        <button v-on:click="getApp()">Get Muster</button>
      </div>
  </div>
</template>

<script>
  export default {
    name: "iOSLanding",
    methods: {
      getApp() {
        location.replace('https://apps.apple.com/us/app/muster/id875311873?mt=8')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/iOSLanding.vue